import { useTranslation } from 'react-i18next';
import {
    Box, 
    Typography
 } from '@mui/material';

import PageContainer from '../components/page-container/PageContainer';

const NotFoundPage = () => {
    const { t } = useTranslation(['translation']);

    return (
        <PageContainer>
            <Box className="not-found-page" sx={{ textAlign: 'center' }}>
                <Typography variant="h4" component="h1" sx={{ marginBottom: '20px' }}>
                    404
                </Typography>
                <Typography variant="body1" sx={{ marginBottom: '20px' }}>
                    {t("404")}
                </Typography>
            </Box>
        </PageContainer>
    );
};

export default NotFoundPage;